const aboutInfo = [
  {
    title: 'Our Values',
    description:
      "We not only stay up to date with all the latest technology developments and best practices, but also use the most innovative techniques to meet the needs of our customers.",
    delay: '0',
  },
  {
    title: 'Mission',
    description:
      'Our mission is to scale up your business by delivering the competitive edge at an affordable price.',
    delay: '100',
  },
  {
    title: 'Strategy',
    description:
      "We take our commitments seriously & deliver value within deadlines, which makes us Authentic.",
    delay: '200',
  },
];

const AboutInfoCards = () => (
 <div className="bg-gray-100 min-h-[40vh] flex flex-col justify-center">
   <div className="grid grid-cols-1  lg:grid-cols-3  gap-8 px-6 py-12 w-full   ">
    {aboutInfo.map((item, index) => (
      <div
        key={index}
        data-aos="zoom-in"
        data-aos-delay={item.delay}
        className="transform"
      >
        <div className="bg-white shadow-md md:hover:scale-105 transform transition-all duration-300 rounded-lg p-6 w-full h-full flex flex-col">
          <h3 className="text-xl mb-2 relative font-semibold">
            {item.title}
            <div className="w-10 h-0.5 bg-[#2584C6] mt-1"></div>
          </h3>
          <p className="text-gray-600 text-sm">{item.description}</p>
        </div>
      </div>
    ))}
  </div>
 </div>
);

export default AboutInfoCards;
